import { createUseStyles } from "react-jss";
import { ITheme } from "../../../constants/theme";
import { COLS, ROWS } from "./keyboardLayout";

export const useStyles = createUseStyles((theme: ITheme) => ({
  "@keyframes slideUp": {
    from: { transform: "translateY(100%)" },
    to: { transform: "translateY(0)" },
  },
  root: {
    position: "fixed",
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: theme.zIndex.dialog,
    boxSizing: "border-box",
    background: "rgba(20, 20, 20, 0.98)",
    borderTop: "1px solid rgba(255, 255, 255, 0.12)",
    animation: "$slideUp 0.2s ease-out",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: `repeat(${COLS}, minmax(0, 1fr))`,
    gridTemplateRows: `repeat(${ROWS}, 80px)`,
    gap: 1,
  },
  key: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: theme.colors.Background3,
    color: theme.colors.TextDefault,
    border: "1px solid transparent",
    borderRadius: 0,
    fontSize: 24,
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "100%",
    cursor: "pointer",
    userSelect: "none",
    "&:hover": {
      background: theme.colors.Background4,
    },
    "&:active": {
      background: "#1877EB",
      transition: "none",
    },
  },
  keyWide: {
    fontSize: 20,
  },
  keyActive: {
    background: theme.colors.Primary,
    borderColor: theme.colors.Primary,
    color: theme.colors.TextDefault,
  },
  selected: {
    border: "3px solid rgba(255, 255, 255, 0.80)",
    zIndex: 1,
  },
  hintChip: {
    position: "absolute",
    top: 0,
    right: 0,
    minWidth: 22,
    height: 22,
    padding: "0 6px",
    borderRadius: "0 0 0 12px",
    background: "#1154A7",
    color: theme.colors.TextDefault,
    fontSize: 11,
    lineHeight: "22px",
    fontWeight: theme.fontWeight.semiBold,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxSizing: "border-box",
  },
  hintIcon: {
    width: 12,
    height: 12,
    display: "block",
  },
}));
